export const tableHeaders = [
  { label: 'ID', value: 'adminUserId' },
  { label: 'Email', value: 'email' },
  { label: 'Name', value: 'firstName' },
  { label: 'Role', value: 'roleId' },
  { label: 'Group', value: 'group' },
  { label: 'Status', value: 'isActive' },
  { label: 'Action', value: 'action' }
]

export const staffTableHeaders = [
  {
    accessorKey: 'adminUserId',
    Header: 'ID',
    value: 'adminUserId',
    label: 'ID',
  },
  {
    accessorKey: 'email',
    Header: 'Email',
    value: 'email',
    label: 'Email',
  },
  {
    accessorKey: 'firstName',
    Header: 'Name',
    value: 'firstName',
    label: 'Name',
  },
  {
    accessorKey: 'roleId',
    Header: 'Role',
    value: 'roleId',
    label: 'Role',
  },
  {
    accessorKey: 'group',
    Header: 'Group',
    value: 'group',
    label: 'Group',
  },
  {
    accessorKey: 'isActive',
    Header: 'Status',
    value: 'isActive',
    label: 'Status',
  },
  {
    accessorKey: 'action',
    Header: 'Action',
    value: 'action',
    label: 'Action',
  },
];

export const ROLES = [
  { roleId: 1, title: 'Super Admin' },
  { roleId: 2, title: 'Admin' },
  { roleId: 3, title: 'Manager' },
  { roleId: 4, title: 'Staff' }
]

export const ADMIN_PERMISSIONS = {
  CMS: ["C", "R", "U", "D", "T"],
  Bonus: ["C", "R", "U", "D", "T", "Issue"],
  Users: ["R", "U", "SR", "AB", "T", "EV", "UP"],
  Admins: ["C", "R", "U", "D", "T"],
  Reviews: ["C", "R", "U"],
  KycLabel: ["C", "R", "U"],
  KpiReport: ["R"],
  Currencies: ["C", "R", "U", "T"],
  GameReport: ["R"],
  BetSettings: ["C", "R", "U", "D"],
  UserComment: ["C", "R"],
  ImageGallery: ["R", "U", "D"],
  Transactions: ["R"],
  EmailTemplate: ["C", "R", "U", "D", "TE"],
  MultiLanguage: ["C", "R", "U"],
  DemographReport: ["R"],
  BannerManagement: ["C", "U", "D"],
  CasinoManagement: ["C", "R", "U", "D", "T"],
  KpiSummaryReport: ["R"],
  LivePlayerReport: ["R"],
  WageringTemplate: ["C", "R", "U"],
  CashierManagement: ["R", "U", "T"],
  LoyaltyManagement: ["R", "U"],
  RegistrationField: ["R", "U"],
  RestrictedCountry: ["R", "U", "D"],
  SiteConfiguration: ["R", "U"],
  TransactionsDriver: ["C", "R", "U", "D", "T"],
  TransactionsBanking: ["C", "R", "U", "D", "T"],
  PlayerLiabilityReport: ["R"],
  PlayerManagementReport: ["R"],
};


// export const StaffStatus = [
//   {label:'Active',value:true},
//   {label:'In active',value:false}
// ]

export const StaffStatus = [
  // { value: '', label: 'Filter by Staff Status' },
  { value: '', label: 'Filter by Status' },
  { value: true, label: 'Active' },
  // { value: 'PENDING', label: 'Pending' },
  { value: false, label: 'In Active' },
  // { value: 'REQUESTED', label: 'Requested' },
  // { value: 'RE_REQUESTED', label: 'Re Requested' }
]